import { List as NovaList } from '@fme-nova/components'
import { default as MuiBaseList, ListProps } from '@mui/material/List'

import { createComponentWrapperWithRef } from '../../theme'

export const List = createComponentWrapperWithRef<ListProps>(
  {
    mui: MuiBaseList,
    nova: NovaList,
  },
  'List',
)
